export const meta = {
  title: '品牌设置:门口挂您的名字,不是我们的',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'catalog'],
};

顾客扫码进入的应用是**您的**——您的店名、您的 Logo、您的配色。我们的名字只以一行小字"网络成员"出现。一切品牌相关的内容都在您的品牌设置里,每次保存立即对顾客生效。

## 您的应用名称

顾客应用以您注册时填写的店名命名——顾客把应用装到手机上时,主屏幕上显示的就是它,每条通知也署这个名。系统会自动生成一个短名称,用在 Android 图标这类狭小空间。

## 您的 Logo

在欢迎向导里上传 Logo,繁琐的部分我们来:Android 和 iPhone 主屏幕所需的每种图标尺寸,加上 iOS 启动画面,都从那一个文件自动生成。上传之前,顾客看到的是一张中性的占位图。

跳过了向导那一步?后台的 Logo 重新上传页面即将推出——目前,向导上传是唯一入口。

## 配色与字体

您的应用默认搭载一套干净的配色和系统字体。自助的配色与字体编辑器正在路上,后台里暂时还没有。

## 营业时间

从排队看板顶栏打开**营业时间**。这个页面决定顾客主屏幕上看到什么、能不能下单:

- **每周时间**——每一天都有独立的开/关切换和时段。两个快捷键省去重复输入:**工作日复制到周末**和**全部套用 9–6**。
- **今日状态**——顶部的实时预览标签(_营业中_、_稍后营业_、*今日休息*等)随您编辑即时更新,保存之前就能看到顾客眼中的样子。

您休息时打开应用的顾客一眼就能看明白——且下单会被暂停,直到您重新营业,不会有人排进一条没人洗车的队。

## 节假日特例

公共假期?点**+ 添加节假日**,选好日期,标记休息——或给它特殊时段。可选的备注("开斋节")告诉顾客原因。特例只在当天覆盖每周时间表。

## 临时歇业

装修,或者休假一周?启用**指定时段歇业**,设好日期范围,写下顾客将看到的消息——例如 _"开斋节歇业,15 号回来"_。歇业期间,它同时覆盖每周时间和节假日特例,顾客应用会在每个关键屏幕上展示这条横幅。

## 公开目录开关

营业时间页面底部是**在公开目录展示我的门店**。打开后,您的正常营业门店会出现在网络的公开查找页上——店名、照片、营业时间、实时等待时长——浏览的车主可以直接跳进您的应用。它默认关闭:不亲手打开,谁也不会被列出。随时可以关掉,从目录里消失;您自己的应用和二维码照常工作。

## 改动立即生效

每次保存都会递增您的品牌版本号,顾客应用下次打开时就会拿到变化——新时间、新 Logo、新歇业横幅。不用清缓存,顾客也不用重装任何东西。
